export default function () {
    let showMoreButtons = document.querySelectorAll('.tags .show-all');
    for (let showMoreButton of showMoreButtons) {
        showMoreButton.onclick = function () {
            showMoreButton.closest('.tags.adv-destroy').classList.toggle("active");
            showMoreButton.classList.toggle("active");
        }
    }

    let tagWrappers = document.querySelectorAll('.tags.adv-destroy');

    for (let tagWrapper of tagWrappers) {
        let showAllBtn = tagWrapper.querySelector('.tags .show-all');
        let showAllBtnWidth = showAllBtn.offsetWidth;

        if (!tagWrapper.classList.contains('inited')) {
            let summ = 0;

            for (let item of tagWrapper.querySelectorAll('.tags-list-wrapper a')) {
                summ += item.offsetWidth;

            }

            if (summ > tagWrapper.offsetWidth - showAllBtnWidth) {
                tagWrapper.classList.add('show');
                tagWrapper.querySelector('.tags-item-list').style.display = 'block';
                showAllBtn.classList.remove('hidden');
            } else {
                showAllBtn.classList.add('hidden');
            }
        }

        tagWrapper.classList.add('inited');
    }
};